import React, { useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { compose } from '../../../../services/utilityFunctions';
import SessionProp from '../../propTypes/sessionProp';
import SessionDocuments from './SessionDocuments';
import ClassroomInfo from './ClassroomInfo';

const TABS = {
  INFORMATION: 'information',
  DOCUMENTS: 'documents',
};

const SessionContentDetails = props => {
  /** Props */
  const { t, session } = props;

  /** State */
  const [tabActive, setTabActive] = useState(TABS.INFORMATION);
  const handleTabChange = tab => setTabActive(tab);

  const wrapperClass = `
    m-portlet
    m-portlet--rounded
    m-portlet--rounded-force
    m-portlet--full-height
    session-details-content-container
  `;

  return (
    <div className={wrapperClass}>
      <div className="classroom-details-wrapper">
        <div className="classroom-details-tabs">
          <button
            type="button"
            onClick={() => handleTabChange(TABS.INFORMATION)}
            className={`tab ${tabActive === TABS.INFORMATION ? 'tab-active' : ''}`}
          >
            <h4>{t('access_session.detail.wizardStep1')}</h4>
          </button>

          <button
            type="button"
            onClick={() => handleTabChange(TABS.DOCUMENTS)}
            className={`tab ${tabActive === TABS.DOCUMENTS ? 'tab-active' : ''}`}
          >
            <h4>{t('access_session.detail.documents')}</h4>
          </button>
        </div>
      </div>
      {
        tabActive === TABS.INFORMATION
        ? <ClassroomInfo session={session} t={t} />
        : <SessionDocuments session={session} />
      }
    </div>
  );
};

SessionContentDetails.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.shape(SessionProp.propType).isRequired,
};
SessionContentDetails.defaultProps = {};

export default compose(
  translate,
)(SessionContentDetails);
